<template>
    <transition name="lazy-component">
        <div v-if="isInit" key="component">
            <slot :loading="loading"></slot>
        </div>
        <div v-else-if="$slots.skeleton" key="skeleton">
            <slot name="skeleton"></slot>
        </div>
        <div v-else key="loading">
        </div>
    </transition>
</template>

<script>
export default {
    name: 'lazyComponent',
    props: {
        timeout: {
            type: Number,
        },
        viewport: {
            type: typeof window !== 'undefined' ? window.HTMLElement : Object,
            default: () => null,
        },
        threshold: {
            type: String,
            default: '80px',
        },
        direction: {
            type: String,
            default: 'vertical',
        },
        maxWaitingTime: {
            type: Number,
            default: 40,
        },
    },
    data() {
        return {
            isInit: false,
            timer: null,
            io: null,
            loading: false,
            lazyLoad: true,
        }
    },
    created() {
        if (!this.timeout) return
        this.timer = setTimeout(() => {
            this.init()
        }, this.timeout)
    },

    mounted() {
        if (!this.timeout) {
            let rootMargin
            switch (this.direction) {
                case 'vertical':
                    rootMargin = `${this.threshold} 0px`
                    break
                case 'horizontal':
                    rootMargin = `0px ${this.threshold}`
                    break
            }
            try {
                this.io = new window.IntersectionObserver(
                    this.intersectionHandler,
                    {
                        rootMargin,
                        root: this.viewport,
                        threshold: [0, Number.MIN_VALUE, 0.01],
                    }
                )
                this.io.observe(this.$el)
            } catch (e) {
                this.init()
            }
        }
    },
    beforeDestroy() {
        if (this.io) {
            this.io.unobserve(this.$el)
        }
    },
    methods: {
        intersectionHandler(entries) {
            if (
                // 正在交叉
                entries[0].isIntersecting ||
                // 交叉率大于0
                entries[0].intersectionRatio
            ) {
                this.init()
                this.io.unobserve(this.$el)
            }
        },
        init() {
            this.$emit('beforeInit')
            this.$emit('before-init')
            this.loading = true
            // 由于函数会在主线程中执行，加载懒加载组件非常耗时，容易卡顿
            // 所以在requestAnimationFrame回调中延后执行
            this.requestAnimationFrame(() => {
                this.isInit = true

                this.$nextTick(() => {
                    this.$emit('init')
                })
            })
        },
        requestAnimationFrame(callback) {
            setTimeout(() => {
                if (this.isInit) return
                callback()
            }, this.maxWaitingTime)
            return (
                window.requestAnimationFrame ||
                ((callback) => setTimeout(callback, 1000 / 60))
            )(callback)
        },
    },
}
</script>

<style scoped>
.lazy-component-enter {
    opacity: 0;
}

.lazy-component-enter-to {
    opacity: 1;
}

.lazy-component-enter-active {
    transition: opacity 0.3s 0.2s;
    position: absolute;
    top: 0;
    width: 100%;
}

.lazy-component-leave {
    opacity: 1;
}

.lazy-component-leave-to {
    opacity: 0;
}

.lazy-component-leave-active {
    transition: opacity 0.5s;
}

</style>